import { CustomerBase } from '../json-schemas/base/customer'
import { LodgingBase } from '../json-schemas/base/lodging'
import { httpDelete, httpGetRoute, httpPut } from '../utils/http.service'
import { I18nService } from '../utils/i18n.service'
import i18nScopedData from './lodgings.service.yml'

const i18nScoped = new I18nService(i18nScopedData)

function lodgingsBasePath (customerId: CustomerBase['id']) {
  if (window.currentUser.type === 'Customer') return `/${httpGetRoute()}/lodgings`
  return `/${httpGetRoute()}/customers/${customerId}/lodgings`
}

export function lodgingsPath (customerId: CustomerBase['id'], id: LodgingBase['id']) {
  return `${lodgingsBasePath(customerId)}/${id}`
}

export async function lodgingsUpdate (customerId: CustomerBase['id'], lodgingId: LodgingBase['id'], body: unknown): Promise<void> {
  return httpPut(`${lodgingsBasePath(customerId)}/${lodgingId}`, { lodging: body })
}

export async function lodgingsDelete (customerId: CustomerBase['id'], lodgingId: LodgingBase['id']): Promise<void> {
  return httpDelete(`${lodgingsBasePath(customerId)}/${lodgingId}`)
}

export function lodgingI18nIcalProvider (icalProvider: LodgingBase['ical_provider']) {
  return i18nScoped.t(`ical_provider.${icalProvider}`)
}

export function lodgingI18nIcalValidationError (validationError: string) {
  return i18nScoped.t(`ical_url_errors.${validationError}`)
}
